import { Component, Inject } from '@angular/core';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CheckReviewService } from '../../services/raintree/Transmission/check-review.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-check-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './check-dialog.component.html',
  styleUrl: './check-dialog.component.scss'
})
export class CheckDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private checkService: CheckReviewService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private dialogRef: MatDialogRef<CheckDialogComponent>
  ) { }
  queryParams: any = { ...this.route.snapshot.queryParams };

  checkDatum() {
    let bodyObj = {
      memKey: this.data.data,
      uiState: this.queryParams['state'],
    };
    if (this.data.review) {
      bodyObj = { ...bodyObj, ...this.data.reqBody }
    }
    console.log(bodyObj);

    this.checkService.checkMemdata(bodyObj).subscribe({
      next: (response) => {
        this.dialog.open(DpSuccessMessageComponent, {
          panelClass: 'common-pannel-dialog-container',
          data: {
            mainHeading: response.message,
            subHeading: '',
            buttonValue: 'Done',
            reload: true,
          },
        });
        this.dialogRef.close(true);
      },
      error: (error) => {
        console.log(error);
        this.toaster.error(error)
        this.dialogRef.close(true);
      },
    });
  }
}
